export const INITIATIVE_TYPES = [{
    value: '1',
    viewValue: 'Competition'
}, {
    value: '2',
    viewValue: 'Program'
}, {
    value: '3',
    viewValue: 'Scholarship'
}];